/*
 * @Author: MX
 * @Date: 2021-03-16 15:24:00
 * @Description:
 */
/**
 * @desc 自定义过滤器
 */
import store from '@/store'
import dayjs from 'dayjs'
// import { cacheHelper } from './cacheHelper'
let langs = null // 国际化数据
// 国际化过滤器
export function lang(str) {
  // if (window.location.href.indexOf('localhost') !== -1) {
  //   if (!store.state.base.langKeyList.includes(str)) store.state.base.langKeyList.push(str)
  // }

  langs = store.state.base.langJson || {}
  return langs[str] || str || ''
}

export function valueToLabel(value, dictList) {
  if (!value && value !== 0) {
    console.warn('id为空，请检查后端接口返回')
    return ''
  }
  if (!dictList || dictList.length === 0) {
    console.warn('字典列表为空，请检查是否传入！')
    return value
  }
  if (!Array.isArray(dictList)) {
    console.warn('dictList必须为数组类型！')
    return value
  }
  // value = Number(value)
  let result = ''
  dictList.forEach(item => {
    const entriesArr = Object.entries(item)
    entriesArr.forEach((item2, index2) => {
      if (value === item2[1]) {
        result = (entriesArr[index2 - 1] || entriesArr[index2 + 1])[1]
      }
    })
  })
  return result
}

export function formatDate(val, formatStr = 'YYYY-MM-DD HH:mm:ss') {
  if (!val) {
    return ''
  }
  return dayjs(new Date(val)).format(formatStr)
}
